export default "__VITE_ASSET__9fc64f42__"